module.exports = __webpack_public_path__ + "img/frame (218).b0b857ca.jpg";